/**
 * @generated SignedSource<<735b2fd1299daeb15bae555ae1aef4fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification$data = {
  readonly projectInviterNotification: {
    readonly emailChannel: {
      readonly isEnabled: boolean | null | undefined;
    } | null | undefined;
    readonly id: string;
  } | null | undefined;
  readonly " $fragmentType": "emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification";
};
export type emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification$key = {
  readonly " $data"?: emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification$data;
  readonly " $fragmentSpreads": FragmentRefs<"emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification",
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "projectInviterNotification",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "projectInviterNotification.id"
        },
        {
          "concreteType": "JiraNotificationChannel",
          "kind": "LinkedField",
          "name": "emailChannel",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNotificationPreferences"
};

(node as any).hash = "e5e47275b0e85a9af56402c3ffb07193";

export default node;
